module.exports = __webpack_public_path__ + "static/media/gallery27.a795adff.jpeg";